import Alert from '@storeblocks/alert';
import { type FC } from 'react';
import styled from 'styled-components';

import { useTexts } from '@/hooks/useTexts';

/**
 * Display a message notifying the user that the
 * files could not be downloaded.
 */
export const DownloadErrorAlert: FC = () => {
  const texts = useTexts();

  return (
    <StyledAlert
      variant="error"
      description={texts.reportsArchivePage.cannotDownloadFiles}
    />
  );
};

const StyledAlert = styled(Alert)`
  margin-top: 24px;
  margin-bottom: 24px;
`;
